import {
  Component,
  ViewChild,
  ElementRef,
  HostListener,
  Renderer2,
  Inject,
  ChangeDetectorRef,
  ViewContainerRef,
  ComponentRef,
} from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import swal from 'sweetalert2';
import { Meta, Title } from '@angular/platform-browser';
import { ApidataService } from '../apidata.service';
import { HeaderComponent } from '..//header/header.component';
import { FooterComponent } from '..//footer/footer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  HttpClient,
  HttpClientModule,
  HttpHeaders,
} from '@angular/common/http';
import { Router, NavigationEnd } from '@angular/router';
import { RouterModule } from '@angular/router';
import { filter } from 'rxjs/operators';
import { MetaTagService } from '../meta-tag.service';
import { FeedbackComponent } from '../feedback/feedback.component';
import { IconsFreeToolsComponent } from '..//icons-free-tools/icons-free-tools.component';
import { environment, GINConstants } from '../../environments/environments';
import { QuillModule } from 'ngx-quill';
import Quill from 'quill';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { PremiumComponent } from "../premium/premium.component";
import { PremiumModalStartupComponent } from '../premium-modal/premium-modal.component';

declare var Dropbox: any;
declare var $: any;
declare var window: any;
declare var gapi: any;
declare var google: any;

@Component({
  selector: 'app-proof-reader',
  standalone: true,
  imports: [
    HeaderComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    FooterComponent,
    RouterModule,
    FeedbackComponent,
    FeedbackComponent,
    IconsFreeToolsComponent,
    QuillModule,
    PremiumComponent,
    PremiumModalStartupComponent,
],
  templateUrl: './proof-reader.component.html',
  styleUrl: './proof-reader.component.css',
})
export class ProofReaderComponent {
  captchaToken: string | null = null;
  editorTxtAI: string;
  activeTab: string = '';
  color: string = 'black';
  homeText = '';
  doc_id = '';
  recaptcha_message = '';
  copried_txt: string = '';
  esubText: string = '';
  esubText2: string = '';
  editortxt = '';
  editortext = '';

  showonlydrive: boolean = false;
  gotresponse: boolean = false;
  showbuttons: boolean = false;
  loaderAlert: boolean = false;
  menuafterresponse: boolean = false;
  copiedtext: boolean = false;
  error: boolean = false;
  checkLogin = false;
  mobilescreen: boolean = false;
  responseformodbile: boolean = false;
  isMenuDropdownVisible = false;
  shouldShowButton: boolean = false;
  got_recpatcha: boolean = false;
  success: boolean = false;

  spellingmistake = 0;
  garmmarmistake = 0;

  char_count = 0;
  word_count = 0;

  EdittorHeight: any;
  EdittorWidth: any;

  errorAlerts;
  successAlert;
  profile_id;
  subscribed_user;

  constructor(
    private renderer: Renderer2,
    @Inject(DOCUMENT) private documenta: Document,
    private webservices: ApidataService,
    private el: ElementRef,
    private router: Router,
    private https: HttpClient,
    private metaService: MetaTagService,
    private cdr: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    private viewContainerRef: ViewContainerRef,
  ) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
  }

  public title: any;
  public description: any;
  private scriptElement: HTMLScriptElement | undefined;
  ngOnInit(): void {
    this.metaService.updateTags(
      'Online Proofreader - Proofread Essays & Papers for Free',
      'Online proofreader polish essays, papers and other professional documents instantly. Get quick and accurate suggestions for flawless writing.',
      'https://www.grammarin.com/online-proofreader',
      'https://www.grammarin.com/assets/images/OG-Images/Free-AI-Proofreader.png',
      'Proofreader'
    );

    this.activeTab = 'q1';
    this.textfromAI();
    this.char_count = $('#editor').text().length;
    this.homeText = $('#editor').text();
    this.word_count = $('#editor').text().split(/\s+/).length;
  }
  ngOnDestroy(): void {
    if (this.scriptElement) {
      this.renderer.removeChild(this.documenta.head, this.scriptElement);
    }
  }
  toggleTab(tabId: string): void {
    if (this.activeTab === tabId) {
      this.activeTab = '';
    } else {
      this.activeTab = tabId;
    }
  }

  textfromAI() {
    if (localStorage.getItem('editorValueAI')) {
      this.showParagraph = false;
    }
    setTimeout(() => {
      if (localStorage.getItem('editorValueAI')) {
        this.editorTxtAI = localStorage.getItem('editorValueAI');
        this.char_count = this.editorTxtAI.length;
        this.word_count = this.editorTxtAI.trim().split(/\s+/).length;
        localStorage.removeItem('editorValueAI');

        if (this.editorTxtAI != null && this.editorTxtAI.length !== 0) {
          this.textDivRef.nativeElement.innerHTML = this.editorTxtAI;
        }
      }
    }, 1000);
  }



  sampletext() {
    const newText =
      "We all are aware of the fact that plagiarism can destroy our careers and websites' credibility. Suppose you have detected that some proportion of your text is plagiarized. In that case, you can opt to use the best article rewriter to make your plagiarized sentences and display their plagiarism-free version in a matter of seconds. It means that it's not only wasted an hour or more trying to rewrite plagiarism from the text yourself and then putting to some responsibility for both of these demanding jobs and providing you 100% unique content in the blink of an eye. There is plagiarism, but only some platforms will provide you with the quality Grammarin offers. This article is jam-packed with top-notch features to facilitate you in the best way possible. You can enjoy the following features.";

    if (this.quill) {
      this.quill.root.innerHTML = newText;
    }

    this.homeText = newText;

    setTimeout(() => {
      this.char_count = this.quill.getText().length;
      this.word_count = this.quill.getText().trim().split(/\s+/).length;
    }, 100);
    this.showParagraph = false;
  }

  // SCROL
  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (window.pageYOffset > 200) {
      this.shouldShowButton = true;
    } else {
      this.shouldShowButton = false;
    }
  }
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  //

  showParagraph: boolean = true;
  @ViewChild('text') text: ElementRef;

  isPopupOpen = false;
  clientId =
    '859452103362-3aroha97qk7nt8ps6ocl70k10pj7uuvt.apps.googleusercontent.com';
  scope = ['profile', 'email', 'https://www.googleapis.com/auth/drive.file'].join(
    ' '
  );
  pickerApiLoaded = false;
  oauthToken?: any;
  @ViewChild('fileInput') fileInput;
  @ViewChild('editor') editor!: ElementRef<HTMLDivElement>;

  showAlert(message, selector) {
    this.errorAlerts = message;
    $(selector).css('border-color', 'red');
    this.error = true;
    $('#errorAlerts').show();
    setTimeout(() => {
      $('#errorAlerts').hide();
      $(selector).css('border-color', '#e7e7ec');
      this.error = false;
    }, 4000);
  }

  showSuccess(message, selector) {
    this.successAlert = message;
    this.success = true;
    $('#successAlert').show();
    setTimeout(() => {
      $('#successAlert').hide();
      $(selector).css('border-color', '#e7e7ec');
      this.success = false;
    }, 4000);
  }

  closeErrorDiv() {
    this.error = false;
  }

  getElementHeightById(id: string): void {
    const element = this.el.nativeElement.querySelector(`#${id}`);
    if (element) {
      this.EdittorHeight = element.clientHeight;
      this.EdittorWidth = element.clientWidth;
    } else {
    }
  }

  uploadFileSaveRedirect(event): void {
    $('#UpFileModal').modal({ backdrop: 'static', keyboard: false });

    const files: FileList = this.fileInput.nativeElement.files;

    var filetype = 'pdf';
    if (files[0].size > 5243000) {
      this.showAlert('File should be less than 5 MB.', '');
    } else {
      let input = event.target;
      this.menuafterresponse = false;
      this.gotresponse = false;
      this.loaderAlert = true;
      this.showParagraph = true;
      this.char_count = 0;
      this.showbuttons = false;
      this.showParagraph = false;
      // var testingnew = document.getElementById('editor');
      // if (testingnew.textContent != 'vv') {
      //   testingnew.textContent = '';
      // }

      $('.hideUpload').hide('slow');
      this.webservices.uploadfilefrombrowser(files).subscribe(
        (data) => {
          this.loaderAlert = false;
          let receivedData = data;
          $('.ql-editor').html(
            receivedData['RetCnt']
              .replace(/&quot;/g, '"')
              .replace(/&#x27;/g, "'")
              .replace(/&amp;/g, /&/g)
              .replace(/&gt;/g, '>')
              .replace(/&lt;/g, '<')
              .replace(/&quot;/g, /"/g)
          );
          this.getContent('', receivedData['RetCnt']);
          this.fileInput.nativeElement.value = '';
          // }
        },
        (error) => {
          this.loaderAlert = false;
          this.showAlert(
            'Unable to proceed with a password protected file.',
            ''
          );
        }
      );
    }
  }
  ////  gDriveUpload functionn

  public gDriveUpload() {
    gapi.load('auth', { callback: this.onAuthApiLoad.bind(this) });
    gapi.load('picker', { callback: this.onPickerApiLoad.bind(this) });
    setTimeout(() => {
      $('.ql-editor').click(); 
    }, 500);
  
  }

  public onAuthApiLoad() {
    gapi.auth.authorize(
      {
        client_id: this.clientId,
        scope: this.scope,
        immediate: false,
      },
      this.handleAuthResult

    );
   
    setTimeout(() => {
      $('.ql-editor').click(); 
    }, 500);
  }

  public onPickerApiLoad() {
    this.pickerApiLoaded = true;
  }

  public handleAuthResult(authResult) {
    $('#UpFileModal').modal('hide');
    let src;

    if (authResult && !authResult.error) {
      if (authResult.access_token) {
        let view = new google.picker.View(google.picker.ViewId.DOCS);
        view.setMimeTypes(
          'application/pdf,application/txt,text/plain,application/vnd.oasis.opendocument.text,application/vnd.google-apps.document,application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        );

        let pickerBuilder = new google.picker.PickerBuilder();
        let picker = pickerBuilder
          .enableFeature(google.picker.Feature.MINE_ONLY)
          .setOAuthToken(authResult.access_token)
          .addView(view)
          .addView(new google.picker.DocsUploadView())
          .setCallback(function (e) {
            if (e.action == google.picker.Action.PICKED) {
              var fileId = e.docs[0].id;
              var file = e.docs[0].url;
              var files = e.docs[0];
              if (files.sizeBytes > 5243000) {
                this.lodershow = false;

                swal({
                  background: '#FFFFFF',
                  title: 'Error',
                  html: `
                  <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
                    background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
                    <div class="text-center" style="margin-top: 9%;">
                      <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
                      <div style="width: 323px; height: 64px; margin-left: 77px;">
                        <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                          File should be less than 5 MB
                        </p>
                      </div>
                      <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
                        border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
                        class="mt-4 butn-alert">Ok</button>
                    </div>
                  </div>
                `,
                  showConfirmButton: false,
                  width: '323px',
                  timer: 4000,
                });

                setTimeout(() => {
                  const okButton = document.getElementById('swal-ok-button');
                  if (okButton) {
                    okButton.addEventListener('click', () => {
                      swal.close();
                    });
                  }
                }, 0);
              } else {
                if (e.docs[0].name.split('.')[1] === 'pdf') {
                  let filelink2 = file + fileId;
                  let linksvalue =
                    'https://drive.google.com/u/0/uc?id=' +
                    fileId +
                    '&export=download';
                  let profile_id = localStorage.getItem('profile_id');
                  $.ajax({
                    url: environment.API_URL + '/api/downloadFromDrive',
                    type: 'post',

                    dataType: 'json',
                    data: {
                      profile_id: profile_id,
                      hash: authResult.access_token,
                      file_path: fileId,
                      file_type: 'pdf',
                      create_chunks: 'false',
                    },
                    beforeSend: function (xhr) {
                      xhr.setRequestHeader(
                        'Authorization',
                        +localStorage.getItem('token')
                      );
                    },

                    success: function (return_data) {
                      $('.ql-editor').html(
                        return_data.RetCnt.replace(/&quot;/g, '"')
                          .replace(/&#x27;/g, "'")
                          .replace(/&amp;/g, /&/g)
                          .replace(/&gt;/g, '>')
                          .replace(/&lt;/g, '<')
                          .replace(/&quot;/g, /"/g)
                      );
                      this.homeText = return_data.RetCnt;
                       
                     
                      setTimeout(() => {
                        $('.ql-editor').click(); 
                      }, 500);
                    },
                    error: function (data) {
                      swal({
                        background: '#FFFFFF',
                        title: 'Error',
                        html: `
      <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
        background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
        <div class="text-center" style="margin-top: 9%;">
          <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
          <div style="    width: 369px; height: 64px; margin-left: 39px;">
            <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
              This file is restricted. Update the public access of your file from \"Restricted\" to \"Anyone with the link.\"
            </p>
          </div>
          <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
            border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
            class="mt-5 butn-alert">Ok</button>
        </div>
      </div>
    `,
                        showConfirmButton: false,
                        width: '323px',
                        timer: 4000,
                      });

                      setTimeout(() => {
                        const okButton =
                          document.getElementById('swal-ok-button');
                        if (okButton) {
                          okButton.addEventListener('click', () => {
                            swal.close();
                          });
                        }
                      }, 0);
                    },
                  });
                } else if (e.docs[0].name.split('.')[1] === 'txt') {
                  let filelink2 = file + fileId;
                  let linksvalue =
                    'https://drive.google.com/u/0/uc?id=' +
                    fileId +
                    '&export=download';

                  if (localStorage.getItem('profile_id')) {
                    var profile_id = localStorage.getItem('profile_id');
                  } else {
                    var profile_id = '1';
                  }
                  $.ajax({
                    url: environment.API_URL + '/api/downloadFromDrive',
                    type: 'post',

                    dataType: 'json',
                    data: {
                      profile_id: profile_id,
                      hash: authResult.access_token,
                      file_path: fileId,
                      file_type: 'txt',
                      create_chunks: 'false',
                    },
                    beforeSend: function (xhr) {
                      xhr.setRequestHeader(
                        'Authorization',
                        +localStorage.getItem('token')
                      );
                    },

                    success: function (return_data) {
                      this.hideothers = true;

                      $('.ql-editor').html(
                        return_data.RetCnt.replace(/&quot;/g, '"')
                          .replace(/&#x27;/g, "'")
                          .replace(/&amp;/g, /&/g)
                          .replace(/&gt;/g, '>')
                          .replace(/&lt;/g, '<')
                          .replace(/&quot;/g, /"/g)
                      );
                      this.homeText = return_data.RetCnt;
                       
                      setTimeout(() => {
                        $('.ql-editor').click(); 
                      }, 500);
                    },
                    error: function (data) {
                      swal({
                        background: '#FFFFFF',
                        title: 'Error',
                        html: `
      <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
        background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
        <div class="text-center" style="margin-top: 9%;">
          <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
          <div style="    width: 369px; height: 64px; margin-left: 39px;">
            <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
              This file is restricted. Update the public access of your file from \"Restricted\" to \"Anyone with the link.\"
            </p>
          </div>
          <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
            border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
            class="mt-5 butn-alert">Ok</button>
        </div>
      </div>
    `,
                        showConfirmButton: false,
                        width: '323px',
                        timer: 4000,
                      });

                      setTimeout(() => {
                        const okButton =
                          document.getElementById('swal-ok-button');
                        if (okButton) {
                          okButton.addEventListener('click', () => {
                            swal.close();
                          });
                        }
                      }, 0);
                    },
                  });
                } else if (e.docs[0].name) {
                  let filelink2 = file + fileId;
                  let linksvalue =
                    'https://docs.google.com/feeds/download/documents/export/Export?id=' +
                    fileId +
                    '&exportFormat=docx';
                  let profile_id = localStorage.getItem('profile_id');
                  $.ajax({
                    url: environment.API_URL + '/api/downloadFromDrive',
                    type: 'post',

                    dataType: 'json',
                    data: {
                      profile_id: profile_id,
                      hash: authResult.access_token,
                      file_path: fileId,
                      file_type: 'docx',
                      create_chunks: 'false',
                    },
                    beforeSend: function (xhr) {
                      xhr.setRequestHeader(
                        'Authorization',
                        +localStorage.getItem('token')
                      );
                    },

                    success: function (return_data) {
                      $('.ql-editor').html(
                        return_data.RetCnt.replace(/&quot;/g, '"')
                          .replace(/&#x27;/g, "'")
                          .replace(/&amp;/g, /&/g)
                          .replace(/&gt;/g, '>')
                          .replace(/&lt;/g, '<')
                          .replace(/&quot;/g, /"/g)
                      );
                      this.homeText = return_data.RetCnt;
                       
                      setTimeout(() => {
                        $('.ql-editor').click(); 
                      }, 500);
                    },
                    error: function (data) {
                      swal({
                        background: '#FFFFFF',
                        title: 'Error',
                        html: `
      <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
        background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
        <div class="text-center" style="margin-top: 9%;">
          <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
          <div style="    width: 369px; height: 64px; margin-left: 39px;">
            <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
              This file is restricted. Update the public access of your file from \"Restricted\" to \"Anyone with the link.\"
            </p>
          </div>
          <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
            border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
            class="mt-5 butn-alert">Ok</button>
        </div>
      </div>
    `,
                        showConfirmButton: false,
                        width: '323px',
                        timer: 4000,
                      });

                      setTimeout(() => {
                        const okButton =
                          document.getElementById('swal-ok-button');
                        if (okButton) {
                          okButton.addEventListener('click', () => {
                            swal.close();
                          });
                        }
                      }, 0);
                    },
                  });
                }
              }
            }
          })
          .build();
        picker.setVisible(true);
      }
    }
  }

  //// dropbox   functionn

  openDropboxChooser(): void {
    // alert('dropbox is calling?')
    const options = {
      success: (files: any) => {
        let fileType = this.getFileType(files[0].name);

        if (fileType === 'docx' || fileType === 'pdf' || fileType === 'txt') {
          this.uploadFileToServer(files[0].link, fileType);
        } else {
        }
      },
      cancel: () => {},
      linkType: 'direct',
      multiselect: false,
      extensions: ['.docx', '.pdf', '.txt'],
      sizeLimit: 1024 * 1024 * 5,
    };
    Dropbox.choose(options);
  }
  getFileType(fileName: string): string {
    const fileExtension = fileName.split('.').pop();
    return fileExtension ? fileExtension.toLowerCase() : '';
  }
  uploadFileToServer(fileLink: string, fileType: string): void {
    this.word_count = 0;
    this.char_count = 0;
    this.spellingmistake = 0;
    this.garmmarmistake = 0;
    this.menuafterresponse = false;
    this.showonlydrive = false;
    this.showParagraph = false;
    this.loaderAlert = true;
    const headers = new HttpHeaders({
      Authorization: environment.AuthorizationGIN,
    });
    var data = {
      file_type: fileType,
      file_path: fileLink,
    };
    this.webservices.dropboxfile(fileType, fileLink).subscribe((data) => {
      let receivedData = data;
      $('.ql-editor').html(
        receivedData['RetCnt']
          .replace(/&quot;/g, '"')
          .replace(/&#x27;/g, "'")
          .replace(/&amp;/g, /&/g)
          .replace(/&gt;/g, '>')
          .replace(/&lt;/g, '<')
          .replace(/&quot;/g, /"/g)
      );
      this.getContent('', receivedData['RetCnt']);
      this.loaderAlert = false;
    });
  }
  /// dropbox  gDriveUpload functionn

  onclickeditor(event: MouseEvent) {
    event.stopPropagation();
    if (this.char_count === 0 && !this.showParagraph) {
      this.word_count = 0;
      this.char_count = 0;
    }
    this.showParagraph = false;
    const sampleText = 'Enter your Text HereORUpload file from above options';
    const editorContent = $('#editor').text().trim();
    if (editorContent === sampleText) {
      this.word_count = 0;
      this.char_count = 0;
    }
    if (editorContent === '') {
      this.word_count = 0;
      this.char_count = 0;
    } else {
      this.word_count = editorContent
        .split(/\s+/)
        .filter((word) => word.length > 0).length;
    }
  }

  ngAfterViewInit(): void {
    this.char_count = $('#editor').text().length;
    this.homeText = $('#editor').text();
    this.word_count = $('#editor').text().split(/\s+/).length;

    this.checkLogin = this.webservices.isLoggedIn();
    if (this.checkLogin) {
      this.profile_id = localStorage.getItem('profile_id');
      // alert(this.profile_id)
    } else {
      this.profile_id = '1';
    }
    const storedStatus = JSON.parse(
      localStorage.getItem('premium_user_done') || 'false'
    );
    this.subscribed_user = storedStatus;
    this.textfromAI();
    this.getElementHeightById('editor');
    this.getBrowserWidth();
    $(window).scroll(function () {
      if ($(this).scrollTop() > 200) {
        $('#scroll-to-top').fadeIn('slow');
      } else {
        $('#scroll-to-top').fadeOut('slow');
      }
    });
    $('#scroll-to-top').click(function () {
      $('html, body').animate({ scrollTop: 0 }, 700);
      return false;
    });

    this.loadLanderComponent();
  }

  @ViewChild('editor') textDivRef!: ElementRef;

  deleteText() {
    $('.ql-editor').html('');
    this.loaderAlert = true;

    if (this.quill) {
      this.quill.setContents([]);
    }

    this.homeText = '';
    this.word_count = 0;
    this.char_count = 0;

    this.showParagraph = true;
    this.loaderAlert = false;
  }

  getBrowserWidth = function () {
    if (window.innerWidth <= 430) {
      this.mobilescreen = true;
      this.responseformodbile = false;
      return 'xs';
    } else if (window.innerWidth < 991) {
      this.mobilescreen = true;
      this.responseformodbile = false;
      return 'sm';
    } else if (window.innerWidth < 1199) {
      this.mobilescreen = true;
      this.responseformodbile = false;
      return 'md';
    } else {
      this.mobilescreen = false;
      this.responseformodbile = false;

      return 'lg';
    }
  };

  getContent(event, text) {
    this.copiedtext = false;
    var ctrlDown = false,
      ctrlKey = 17,
      cmdKey = 91,
      vKey = 86,
      cKey = 67;
    this.editortext = text;
    this.char_count = $('#editor').text().length;
    this.word_count = $('#editor').text().split(/\s+/).length;
    if (ctrlDown && event.keyCode == vKey) {
      this.showParagraph = false;
      var editortxt = $('#editor').text();
    }
    var editortxt = $('#editor').text();
    this.handleCheckGrammarButton();
  }

  public saveTextRedirect() {
    $('#editor').find('span').contents().unwrap();

    this.editortxt = this.quillEditor.scroll.domNode.innerHTML;
    setTimeout(() => {
      this.quill.root.querySelectorAll('img').forEach((img) => img.remove());
    }, 0);

    if (
      this.editortxt !=
      'Upload Your ContentType or Paste AI Text hereSample TextPaste text'
    ) {
      this.char_count = $('#editor').text().length;
      this.word_count = $('#editor').text().trim().split(/\s+/).length;

      const trimmedText = this.editortxt.trim();
      if (trimmedText.length === 0) {
        this.showAlert('Error: Input is empty or only spaces.', '');

        return;
      } else {
        if (this.editortxt.length > 0) {
          this.loaderAlert = true;
          let data2 = JSON.stringify({
            homeText: this.editortxt,
            profile_id: this.profile_id,
          });

          let url =
            environment.API_URL + '/api/getNewDocIDForGuestByContents';

          this.webservices.postResources(data2, url).subscribe((data) => {
            let receivedData = data;

            this.doc_id = receivedData['new_doc_id'];

            // this.router.navigate(['/document/', this.doc_id]);
            this.router.navigate(['/grammar-check'], {
              queryParams: { doc: this.doc_id },
            });
            var editortxt = '';
            editortxt = this.homeText;
            localStorage.setItem('editorValueAI', editortxt);
            const url = this.router.serializeUrl(
              this.router.createUrlTree([''])
            );
            // }
          });
        }
      }
    } else {
      this.showAlert('Error: Please add atleast 1 word to proceed.', '');
    }
  }

  handlePaste(event: ClipboardEvent): void {
    const clipboardData = event.clipboardData || window.clipboardData;
    const pastedData = clipboardData.getData('text/plain');

    event.preventDefault();
    document.execCommand('insertText', false, pastedData);

    this.updateWordCountPaste();
    this.showParagraph = false;
  }

  onInput(): void {
    const editableDiv = document.getElementById('editor') as HTMLElement;

    if (editableDiv) {
      const textContent = editableDiv.innerText;

      this.updateWordCountPaste();
    }
  }

  updateWordCountPaste(): void {
    const editableDiv = document.getElementById('editor') as HTMLElement;

    if (editableDiv) {
      const textContent = editableDiv.innerText;
      this.char_count = textContent.length;
      this.word_count = textContent
        .trim()
        .split(/\s+/)
        .filter((word) => word.length > 0).length;
    }
  }
  captchaVisible: boolean = false;
  isCaptchaVerified: boolean = false;
  recaptchaMessage: string = '';

  handleButtonClick(): void {
    if (this.loaderAlert) {
      return;
    }
    $('#editor').find('span').contents().unwrap();
    this.char_count = $('#editor').text().length;
    this.word_count = $('#editor')
      .text()
      .trim()
      .split(/\s+/)
      .filter((word) => word.length > 0).length;

    if (this.word_count === 0) {
      this.showAlert('Error: Please add at least 1 word to proceed.', '');
      return;
    }

    if (this.isCaptchaVerified) {
      this.saveTextRedirect();
    } else {
      if (!this.captchaVisible) {
        this.captchaVisible = true;
        this.cdr.detectChanges();
        this.loadAndRenderTurnstile();
      } else {
        this.recaptchaMessage = 'Please complete the CAPTCHA.';
        this.color = '#721c24';
      }
    }
  }

  showCaptchaModal(): void {
    if (!this.captchaVisible) {
      this.captchaVisible = true;
      this.cdr.detectChanges();
      this.loadAndRenderTurnstile();
    } else {
      this.recaptchaMessage = 'Please complete the CAPTCHA.';
      this.color = '#721c24';
    }
  }

  loadAndRenderTurnstile(): void {
    if (typeof window['turnstile'] === 'undefined') {
      const script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
      script.async = true;
      script.defer = true;
      script.onload = () => this.renderTurnstile();
      script.onerror = () => console.error('Failed to load Turnstile script.');
      document.body.appendChild(script);
    } else {
      this.renderTurnstile();
    }
  }

  renderTurnstile(): void {
    const containerElement = document.getElementById('recaptcha-container');
    if (!containerElement) {
      // console.error('Container element not found.');
      return;
    }

    window['turnstile'].render(containerElement, {
      sitekey: environment.CaptchaKey,
      size: 'normal',
      callback: (token: string) => this.onTurnstileSuccess(token),
      'error-callback': () => this.onTurnstileError(),
    });
    // console.log('Turnstile rendered successfully.');
  }

  onTurnstileSuccess(token: string): void {
    // console.log('Turnstile token received:', token);
    this.captchaToken = token;
    this.isCaptchaVerified = true;
    this.captchaVisible = false;
    this.recaptchaMessage = '';
    this.saveTextRedirect();
  }

  // Callback for CAPTCHA error (if verification fails)
  onTurnstileError(): void {
    console.error('Turnstile error occurred.');
    this.captchaToken = null;
    this.recaptchaMessage = 'CAPTCHA verification failed. Please try again.';
    this.color = '#721c24';
  }

  // Reset CAPTCHA in case of error or retry
  resetTurnstile(): void {
    const containerElement = document.getElementById('recaptcha-container');
    if (typeof window['turnstile'] !== 'undefined') {
      window['turnstile'].reset(containerElement);
      // console.log('Turnstile CAPTCHA reset.');
    } else {
      // console.error('Turnstile library not loaded.');
    }
  }

  executeAction(action: string) {
    if (this[action] && typeof this[action] === 'function') {
      this[action]();
    } else {
      console.error(`Action "${action}" is not a valid method.`);
    }
  }

  //  objects objects objects

  contentArray = [
    {
      showParagraph: true,
      header: 'Upload Your Content',
      paragraph: 'Type or Paste AI Text here',
      buttons: [
        {
          text: 'Sample Text',
          icon: 'copyIcon',
          action: 'sampletext',
        },
        {
          text: 'Paste Text',
          icon: 'copyIcon',
          action: 'pasteText',
        },
      ],
    },
  ];

  guideToProofreading = [
    {
      title: 'Grammar and Syntax',
      items: [
        { name: 'Grammar', href: 'https://www.grammarin.com/handbook/grammar' },
        {
          name: 'Modifiers',
          href: 'https://www.grammarin.com/what-are-modifiers',
        },
        { name: 'Nouns', href: 'https://www.grammarin.com/what-are-nouns' },
        {
          name: 'Prepositions',
          href: 'https://www.grammarin.com/what-are-prepositions',
        },
      ],
      icon: 'arrowIcon',
    },
    {
      title: 'Punctuation and Spelling',
      items: [
        {
          name: 'Punctuation',
          href: 'https://www.grammarin.com/handbook/punctuation',
        },
        { name: 'Colon', href: 'https://www.grammarin.com/what-is-a-colon' },
        {
          name: 'Semicolon',
          href: 'https://www.grammarin.com/what-is-a-semicolon',
        },
        { name: 'Comma', href: 'https://www.grammarin.com/what-is-a-comma' },
      ],
      icon: 'arrowIcon',
    },
    {
      title: 'Grammar Mechanics',
      items: [
        {
          name: 'Mechanics',
          href: 'https://www.grammarin.com/handbook/mechanics',
        },
        {
          name: 'Abbreviations',
          href: 'https://www.grammarin.com/what-is-abbreviation',
        },
        {
          name: 'Contractions',
          href: 'https://www.grammarin.com/what-are-contractions',
        },
        {
          name: 'Compound Words',
          href: 'https://www.grammarin.com/what-are-compound-words',
        },
      ],
      icon: 'arrowIcon',
    },
  ];

  cards3 = [
    {
      icon: 'mulyipleWays',
      heading: 'Multiple Ways',
      description: 'AI-powered or human',
    },
    {
      icon: 'correctIcon',
      heading: 'Correct',
      description: 'Writing Style',
    },
    {
      icon: 'dialectsIcon',
      heading: 'Dialects',
      description: 'UK & US English',
    },
    {
      icon: 'freeIcon',
      heading: '100% Free',
      description: 'Unlimited Usage',
    },
  ];

  TWCF = [
    {
      icon: 'teacherIcon',
      heading: 'Teachers',
      description:
        "Grading all the assignments and papers could be hectic for teachers. So they can use the free proofreader to identify mistakes in the students' written projects in less time.",
    },
    {
      icon: 'websiteIcon',
      heading: 'Website Owners',
      description:
        'Writing content to drive traffic requires precision and accuracy in the blogs. With the proofreading software, webmasters can ensure purity of their uploaded content.',
    },
    {
      icon: 'writerIcon',
      heading: 'Content Writers',
      description:
        'Content writers can easily identify and correct the writing blunders in their content before posting it. The professional proofreader makes it easier to proofread the content in all the writing styles without extra settings.',
    },
    {
      icon: 'freelancersicon',
      heading: 'Freelancers',
      description:
        'With the online proofreader, freelancers can show their professionalism to their clients by rectifying mistakes on a deep level. Their content becomes accurate and reliable, which helps them gain a positive reputation.',
    },
  ];

  Tools = [
    {
      icon: 'pasteIcon',
      description: 'Paste text or upload file directly from your system.',
    },
    {
      icon: 'hitheIcon',
      description: 'Hit the “Proofread” button to initiate the process.',
    },
    {
      icon: 'proofreadicon',
      description: 'The proofreader will highlight all the mistakes.',
    },
    {
      icon: 'highlightedicon',
      description:
        'Now, tap each highlighted text to get suggestions for improvement.',
    },
  ];

  sections = [
    {
      title: 'GrammarIn Proofreading Tool for Students',
      description: `Students write throughout their academic life. From the initial grades
                  to higher education, they must write many assignments, projects,
                  essays, and reports. To improve their grammar and rectify mistakes,
                  they can leverage free proofreading. It has specific tools specially
                  designed for the students.`,
    },
  ];
  easyPaper = [
    {
      title: 'Essay Proofreader',
      description: `The essay proofreader is designed to revise and edit essays. It
                  provides settings for every type of essay of all grades. The essay
                  improver does an excellent job of proofreading academic essays by
                  suggesting accurate corrections.`,
    },
    {
      title: 'Paper Proofreader',
      description: `For students with a master's level education, GrammarIn also offers
                  a paper proofreader. It is trained to analyze the content of the
                  thesis, paper, and report. The paper proofreader suggests an
                  academic tone and wording for better and well-structured papers.`,
    },
  ];

  CG = [
    {
      icon: 'customizabilityIcon',
      title: 'Customizability for Different Writing Styles',
      description: `The online proofreader is programmed to work for all types of
                  writing styles. The suggested corrections by this tool will not
                  affect the writing tone of your content. You can also use it to
                  correct all writing genres.`,
    },
    {
      icon: 'accuracyIcon',
      title: 'Grammar and Spelling Accuracy',
      description: `Every sentence is meticulously analyzed for grammar and spelling
                  errors. You can also take advantage of the built-in
                  <a href="https://www.grammarin.com/grammar-checker" target="_blank" rel="noopener noreferrer" style="text-decoration: underline !important; color: #007bff !important;" class="href-style">grammar checker</a>
                  for even more comprehensive grammar fixes.`,
    },
  ];
  EDU = [
    {
      icon: 'professionalismIcon',
      title: 'Enhanced Professionalism',
      description: `The online proofreader enhances the professionalism of your documents by
                  correcting all the grammatical errors. It identifies the smallest
                  mistakes, such as missed punctuation or errors in subject-verb
                  agreement.`,
    },
    {
      icon: 'dataPrivacyIcon',
      title: 'Data Privacy and Security Measures',
      description: `You do not have to worry about data security. All the data entered
                  by the users is kept safe under the strict privacy policy. Your
                  content is not sold to third parties for unauthorized use.`,
    },
    {
      icon: 'userFriendlyIcon',
      title: 'User-Friendly Interface and Functionality',
      description: `The online proofreader is designed with simplicity in mind. Users
                  can use it without any hassle because of its easy to use design.
                  They can access all functions effortlessly.`,
    },
  ];
  // ----------paste method --------

  pasteText(): void {
    navigator.clipboard
      .read()
      .then((clipboardItems) => {
        for (const item of clipboardItems) {
          for (const type of item.types) {
            if (type === 'text/html') {
              item.getType(type).then((blob) => {
                blob.text().then((html) => {
                  this.showParagraph = false;

                  const tempDiv = document.createElement('div');
                  tempDiv.innerHTML = html;

                  tempDiv
                    .querySelectorAll('script')
                    .forEach((script) => script.remove());

                  // Remove all <img> elements
                  tempDiv
                    .querySelectorAll('img')
                    .forEach((img) => img.remove());
                  tempDiv
                    .querySelectorAll('video')
                    .forEach((video) => video.remove());

                  tempDiv.querySelectorAll('*').forEach((el) => {
                    const element = el as HTMLElement;
                    element.removeAttribute('id');
                    element.removeAttribute('class');

                    if (element.style.backgroundImage) {
                      element.style.backgroundImage = 'none';
                    }

                    element.style.background = 'none';
                    element.style.backgroundColor = 'transparent';
                    element.style.color = 'black';
                  });
                  const emojiRegex =
                    /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/gu;
                  let modifiedContent = tempDiv.innerHTML.replace(
                    emojiRegex,
                    ''
                  );
                  // const modifiedContent = tempDiv.innerHTML;
                  if (this.quill) {
                    this.quill.clipboard.dangerouslyPasteHTML(
                      this.quill.getSelection()?.index || 0,
                      modifiedContent
                    );

                    setTimeout(() => {
                      this.char_count = this.quill.getText().length;
                      this.word_count = this.quill
                        .getText()
                        .trim()
                        .split(/\s+/).length;
                    }, 100);
                  }
                });
              });
              return;
            }
          }
        }
      })
      .catch((err) => {
        // console.error("Failed to read clipboard contents: ", err);
      });
  }

  quill: Quill | undefined;
  onHandleFormatting(quillInstance: Quill) {
    this.quill = quillInstance;

    this.quill.root.addEventListener('paste', (event: ClipboardEvent) => {
      event.preventDefault();

      this.showParagraph = false;

      setTimeout(() => {
        let quillContent = this.quill.root.innerHTML;

        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = quillContent;

        tempDiv
          .querySelectorAll('input[type="checkbox"], input[type="radio"]')
          .forEach((input) => input.remove());
        tempDiv
          .querySelectorAll('app-icons-free-tools')
          .forEach((icon) => icon.remove());
        tempDiv
          .querySelectorAll('script, img, svg, video, iframe, embed')
          .forEach((el) => el.remove());

        tempDiv.querySelectorAll('iframe').forEach((iframe) => {
          const src = (iframe as HTMLIFrameElement).src;
          if (src.includes('youtube.com') || src.includes('youtu.be')) {
            iframe.remove();
          }
        });

        tempDiv.querySelectorAll('*').forEach((el) => {
          const element = el as HTMLElement;
          element.style.background = 'none';
          element.style.backgroundColor = 'transparent';
          element.style.color = 'black';
          element.removeAttribute('id');
          element.removeAttribute('class');
        });

        const emojiRegex =
          /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/gu;
        let modifiedContent = tempDiv.innerHTML
          .replace(emojiRegex, '')
          .replace(/\s+/g, ' ')
          .trim();

        this.quill.setContents([]);
        this.quill.clipboard.dangerouslyPasteHTML(0, modifiedContent);

        this.sanitizedContent = this.sanitizer.bypassSecurityTrustHtml(
          tempDiv.innerHTML
        );

        setTimeout(() => {
          this.char_count = this.quill.getText().length;
          this.word_count = this.quill.getText().trim().split(/\s+/).length;
        }, 100);

        this.removeImagesFromQuill();
        this.handleCheckGrammarButton();

        for (let i = 0; i <= 100; i += 10) {
          setTimeout(() => {
            this.quill.root
              .querySelectorAll('img')
              .forEach((img) => img.remove());
          }, 5);
        }
      }, 0);
    });


  }
 
  removeImagesFromQuill() {
    setTimeout(() => {
      this.quill.root.querySelectorAll('img').forEach((img) => img.remove());
    }, 0);
  }
  sanitizedContent: SafeHtml;
  handleCheckGrammarButton() {
    if (!this.quillEditor || !this.quillEditor.root) {
      console.error(
        'Quill editor is not initialized yet. Retrying in 100ms...'
      );
      setTimeout(() => this.handleCheckGrammarButton(), 100);
      return;
    }

    this.quillEditor.root
      .querySelectorAll('img')
      .forEach((img) => img.remove());

    setTimeout(() => {
      if (this.quillEditor.root.innerText.trim().length === 0) {
        this.quillEditor.root
          .querySelectorAll('img')
          .forEach((img) => img.remove());
        this.quillEditor.enable();
      }
    }, 0);
  }
  quillEditor: any;
  onEditorCreated(quillInstance: Quill) {
    this.quillEditor = quillInstance;

    this.quillEditor.on('text-change', (delta, oldDelta, source) => {
      if (source === 'user') {
        this.updateEditorContent();
      }
    });

    this.updateEditorContent();
  }
  updateEditorContent() {
    if (!this.quillEditor) return;

    this.homeText = this.quillEditor.root.innerHTML;
    this.char_count = this.quillEditor.getText().trim().length;
    this.word_count = this.quillEditor
      .getText()
      .trim()
      .split(/\s+/)
      .filter((word) => word.length > 0).length;
  }
  // Custom toolbar configuration

  editorModules = {
    toolbar: false,
    //  [
    // ['bold', 'italic', 'underline'], // Text styling options
    // [{ list: 'ordered' }, { list: 'bullet' }], // Lists
    // [{ header: [1, 2, 3, false] }], // Header levels
    // ['link'], // Links

    // ],
  };

  // ----------paste method --------
    count_Words_Character2() {
  
      this.char_count = this.quillEditor.getText().trim().length;
      this.word_count = this.quillEditor
        .getText()
        .trim()
        .split(/\s+/)
        .filter((word) => word.length > 0).length;
        this.char_count = $('.ql-editor').text().length;
        this.word_count = $('.ql-editor').text().split(/\s+/).length;
    }

    @ViewChild('landerContainer', { read: ViewContainerRef, static: false }) landerContainer!: ViewContainerRef;
    landerComponentRef: ComponentRef<any> | null = null;
    isLanderLoaded = false;

    async loadLanderComponent() {
      if (this.isLanderLoaded || !this.landerContainer) return;
      const { LanderComponent } = await import('../grammarchecker/additional/lander.component');
      this.landerComponentRef = this.landerContainer.createComponent(LanderComponent);
      this.isLanderLoaded = true;
    }
}
